import { userOrgApi as api } from './userOrgSlice';
const injectedRtkApi = api.injectEndpoints({
    endpoints: build => ({
        getApiEnumsRequestStates: build.query<GetApiEnumsRequestStatesApiResponse, GetApiEnumsRequestStatesApiArg>({
            query: () => ({ url: `/api/Enums/RequestStates` }),
        }),
        getApiEnumsRequestTypes: build.query<GetApiEnumsRequestTypesApiResponse, GetApiEnumsRequestTypesApiArg>({
            query: () => ({ url: `/api/Enums/RequestTypes` }),
        }),
        getApiEnumsOperationModeResponses: build.query<
            GetApiEnumsOperationModeResponsesApiResponse,
            GetApiEnumsOperationModeResponsesApiArg
        >({
            query: () => ({ url: `/api/Enums/OperationModeResponses` }),
        }),
        getApiHeappeListChangedFilesForJobByProjectShortNameAndResourceNameSubmittedJobInfoId: build.query<
            GetApiHeappeListChangedFilesForJobByProjectShortNameAndResourceNameSubmittedJobInfoIdApiResponse,
            GetApiHeappeListChangedFilesForJobByProjectShortNameAndResourceNameSubmittedJobInfoIdApiArg
        >({
            query: queryArg => ({
                url: `/api/Heappe/ListChangedFilesForJob/${queryArg.projectShortName}/${queryArg.resourceName}/${queryArg.submittedJobInfoId}`,
            }),
        }),
        getApiOtherCountry: build.query<GetApiOtherCountryApiResponse, GetApiOtherCountryApiArg>({
            query: queryArg => ({ url: `/api/Other/Country`, params: { CountryCode: queryArg.countryCode } }),
        }),
        getApiOtherStatistics: build.query<GetApiOtherStatisticsApiResponse, GetApiOtherStatisticsApiArg>({
            query: queryArg => ({
                url: `/api/Other/Statistics`,
                params: { fromDate: queryArg.fromDate, toDate: queryArg.toDate },
            }),
        }),
        getApiOtherCyclopsUsageByProjectShortNameAndResourceName: build.query<
            GetApiOtherCyclopsUsageByProjectShortNameAndResourceNameApiResponse,
            GetApiOtherCyclopsUsageByProjectShortNameAndResourceNameApiArg
        >({
            query: queryArg => ({
                url: `/api/Other/CyclopsUsage/${queryArg.projectShortName}/${queryArg.resourceName}`,
                params: { fromDate: queryArg.fromDate, toDate: queryArg.toDate },
            }),
        }),
        getApiProjectByProjectShortNameUsers: build.query<
            GetApiProjectByProjectShortNameUsersApiResponse,
            GetApiProjectByProjectShortNameUsersApiArg
        >({
            query: queryArg => ({ url: `/api/Project/${queryArg.projectShortName}/Users` }),
        }),
        getProject: build.query<GetProjectApiResponse, GetProjectApiArg>({
            query: queryArg => ({ url: `/api/Project`, params: { ProjectShortName: queryArg.projectShortName } }),
        }),
        postApiProject: build.mutation<PostApiProjectApiResponse, PostApiProjectApiArg>({
            query: queryArg => ({ url: `/api/Project`, method: 'POST', body: queryArg.projectCreate }),
        }),
        putApiProject: build.mutation<PutApiProjectApiResponse, PutApiProjectApiArg>({
            query: queryArg => ({ url: `/api/Project`, method: 'PUT', body: queryArg.projectUpdate }),
        }),
        putApiProjectByProjectShortNameUserAndIdpUserIdAssignRoleId: build.mutation<
            PutApiProjectByProjectShortNameUserAndIdpUserIdAssignRoleIdApiResponse,
            PutApiProjectByProjectShortNameUserAndIdpUserIdAssignRoleIdApiArg
        >({
            query: queryArg => ({
                url: `/api/Project/${queryArg.projectShortName}/User/${queryArg.idpUserId}/Assign/${queryArg.roleId}`,
                method: 'PUT',
            }),
        }),
        deleteApiProjectByProjectShortName: build.mutation<
            DeleteApiProjectByProjectShortNameApiResponse,
            DeleteApiProjectByProjectShortNameApiArg
        >({
            query: queryArg => ({ url: `/api/Project/${queryArg.projectShortName}`, method: 'DELETE' }),
        }),
        putApiProjectByProjectShortNameProjectResourceAndProjectResourceName: build.mutation<
            PutApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiResponse,
            PutApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiArg
        >({
            query: queryArg => ({
                url: `/api/Project/${queryArg.projectShortName}/ProjectResource/${queryArg.projectResourceName}`,
                method: 'PUT',
            }),
        }),
        deleteApiProjectByProjectShortNameProjectResourceAndProjectResourceName: build.mutation<
            DeleteApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiResponse,
            DeleteApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiArg
        >({
            query: queryArg => ({
                url: `/api/Project/${queryArg.projectShortName}/ProjectResource/${queryArg.projectResourceName}`,
                method: 'DELETE',
            }),
        }),
        putApiProjectByProjectShortNameUserAndIdpUserId: build.mutation<
            PutApiProjectByProjectShortNameUserAndIdpUserIdApiResponse,
            PutApiProjectByProjectShortNameUserAndIdpUserIdApiArg
        >({
            query: queryArg => ({
                url: `/api/Project/${queryArg.projectShortName}/User/${queryArg.idpUserId}`,
                method: 'PUT',
            }),
        }),
        deleteApiProjectByProjectShortNameUserAndIdpUserId: build.mutation<
            DeleteApiProjectByProjectShortNameUserAndIdpUserIdApiResponse,
            DeleteApiProjectByProjectShortNameUserAndIdpUserIdApiArg
        >({
            query: queryArg => ({
                url: `/api/Project/${queryArg.projectShortName}/User/${queryArg.idpUserId}`,
                method: 'DELETE',
            }),
        }),
        putApiProjectByProjectShortNameProjectTagAndProjectTagId: build.mutation<
            PutApiProjectByProjectShortNameProjectTagAndProjectTagIdApiResponse,
            PutApiProjectByProjectShortNameProjectTagAndProjectTagIdApiArg
        >({
            query: queryArg => ({
                url: `/api/Project/${queryArg.projectShortName}/ProjectTag/${queryArg.projectTagId}`,
                method: 'PUT',
            }),
        }),
        deleteApiProjectByProjectShortNameProjectTagAndProjectTagId: build.mutation<
            DeleteApiProjectByProjectShortNameProjectTagAndProjectTagIdApiResponse,
            DeleteApiProjectByProjectShortNameProjectTagAndProjectTagIdApiArg
        >({
            query: queryArg => ({
                url: `/api/Project/${queryArg.projectShortName}/ProjectTag/${queryArg.projectTagId}`,
                method: 'DELETE',
            }),
        }),
        templatesInfo: build.query<TemplatesInfoApiResponse, TemplatesInfoApiArg>({
            query: queryArg => ({
                url: `/api/Project/TemplatesInfo/${queryArg.projectShortName}`,
                params: { noCache: queryArg.noCache },
            }),
        }),
        extendedProjectInfo: build.query<ExtendedProjectInfoApiResponse, ExtendedProjectInfoApiArg>({
            query: queryArg => ({
                url: `/api/Project/ExtendedProjectInfo`,
                params: { ProjectShortName: queryArg.projectShortName },
            }),
        }),
        validRoles: build.query<ValidRolesApiResponse, ValidRolesApiArg>({
            query: queryArg => ({ url: `/api/Project/${queryArg.projectShortName}/ValidRoles` }),
        }),
        getApiProjectResourceAssignment: build.query<
            GetApiProjectResourceAssignmentApiResponse,
            GetApiProjectResourceAssignmentApiArg
        >({
            query: queryArg => ({
                url: `/api/ProjectResourceAssignment`,
                params: { ProjectResourceId: queryArg.projectResourceId },
            }),
        }),
        postApiProjectResourceAssignment: build.mutation<
            PostApiProjectResourceAssignmentApiResponse,
            PostApiProjectResourceAssignmentApiArg
        >({
            query: queryArg => ({
                url: `/api/ProjectResourceAssignment`,
                method: 'POST',
                body: queryArg.projectResourceAssignmentCreate,
            }),
        }),
        putApiProjectResourceAssignment: build.mutation<
            PutApiProjectResourceAssignmentApiResponse,
            PutApiProjectResourceAssignmentApiArg
        >({
            query: queryArg => ({
                url: `/api/ProjectResourceAssignment`,
                method: 'PUT',
                body: queryArg.projectResourceAssignmentUpdate,
            }),
        }),
        getProjectResourceAssignment: build.query<
            GetProjectResourceAssignmentApiResponse,
            GetProjectResourceAssignmentApiArg
        >({
            query: queryArg => ({ url: `/api/ProjectResourceAssignment/${queryArg.id}` }),
        }),
        deleteApiProjectResourceAssignmentById: build.mutation<
            DeleteApiProjectResourceAssignmentByIdApiResponse,
            DeleteApiProjectResourceAssignmentByIdApiArg
        >({
            query: queryArg => ({ url: `/api/ProjectResourceAssignment/${queryArg.id}`, method: 'DELETE' }),
        }),
        getApiProjectResource: build.query<GetApiProjectResourceApiResponse, GetApiProjectResourceApiArg>({
            query: queryArg => ({
                url: `/api/ProjectResource`,
                params: {
                    ProjectShortName: queryArg.projectShortName,
                    LocationTypeId: queryArg.locationTypeId,
                    StartDate: queryArg.startDate,
                    EndDate: queryArg.endDate,
                },
            }),
        }),
        postApiProjectResource: build.mutation<PostApiProjectResourceApiResponse, PostApiProjectResourceApiArg>({
            query: queryArg => ({ url: `/api/ProjectResource`, method: 'POST', body: queryArg.projectResourceCreate }),
        }),
        putApiProjectResource: build.mutation<PutApiProjectResourceApiResponse, PutApiProjectResourceApiArg>({
            query: queryArg => ({ url: `/api/ProjectResource`, method: 'PUT', body: queryArg.projectResourceUpdate }),
        }),
        getProjectResource: build.query<GetProjectResourceApiResponse, GetProjectResourceApiArg>({
            query: queryArg => ({ url: `/api/ProjectResource/${queryArg.id}` }),
        }),
        deleteApiProjectResourceById: build.mutation<
            DeleteApiProjectResourceByIdApiResponse,
            DeleteApiProjectResourceByIdApiArg
        >({
            query: queryArg => ({ url: `/api/ProjectResource/${queryArg.id}`, method: 'DELETE' }),
        }),
        getApiProjectTag: build.query<GetApiProjectTagApiResponse, GetApiProjectTagApiArg>({
            query: queryArg => ({ url: `/api/ProjectTag`, params: { TagName: queryArg.tagName } }),
        }),
        postApiProjectTag: build.mutation<PostApiProjectTagApiResponse, PostApiProjectTagApiArg>({
            query: queryArg => ({ url: `/api/ProjectTag`, method: 'POST', body: queryArg.projectTagCreate }),
        }),
        putApiProjectTag: build.mutation<PutApiProjectTagApiResponse, PutApiProjectTagApiArg>({
            query: queryArg => ({ url: `/api/ProjectTag`, method: 'PUT', body: queryArg.projectTagUpdate }),
        }),
        getProjectTag: build.query<GetProjectTagApiResponse, GetProjectTagApiArg>({
            query: queryArg => ({ url: `/api/ProjectTag/${queryArg.id}` }),
        }),
        deleteApiProjectTagById: build.mutation<DeleteApiProjectTagByIdApiResponse, DeleteApiProjectTagByIdApiArg>({
            query: queryArg => ({ url: `/api/ProjectTag/${queryArg.id}`, method: 'DELETE' }),
        }),
        getApiRequests: build.query<GetApiRequestsApiResponse, GetApiRequestsApiArg>({
            query: queryArg => ({
                url: `/api/Requests`,
                params: { State: queryArg.state, Type: queryArg['type'], ProjectShortName: queryArg.projectShortName },
            }),
        }),
        postApiRequests: build.mutation<PostApiRequestsApiResponse, PostApiRequestsApiArg>({
            query: queryArg => ({ url: `/api/Requests`, method: 'POST', body: queryArg.requestCreate }),
        }),
        getApiRequestsSentRequests: build.query<
            GetApiRequestsSentRequestsApiResponse,
            GetApiRequestsSentRequestsApiArg
        >({
            query: queryArg => ({
                url: `/api/Requests/SentRequests`,
                params: { State: queryArg.state, Type: queryArg['type'], ProjectShortName: queryArg.projectShortName },
            }),
        }),
        putApiRequestsByRequestIdAccept: build.mutation<
            PutApiRequestsByRequestIdAcceptApiResponse,
            PutApiRequestsByRequestIdAcceptApiArg
        >({
            query: queryArg => ({ url: `/api/Requests/${queryArg.requestId}/Accept`, method: 'PUT' }),
        }),
        putApiRequestsByRequestIdReject: build.mutation<
            PutApiRequestsByRequestIdRejectApiResponse,
            PutApiRequestsByRequestIdRejectApiArg
        >({
            query: queryArg => ({
                url: `/api/Requests/${queryArg.requestId}/Reject`,
                method: 'PUT',
                params: { Reason: queryArg.reason },
            }),
        }),
        getApiUserPreferences: build.query<GetApiUserPreferencesApiResponse, GetApiUserPreferencesApiArg>({
            query: () => ({ url: `/api/User/Preferences` }),
        }),
        putApiUserPreferences: build.mutation<PutApiUserPreferencesApiResponse, PutApiUserPreferencesApiArg>({
            query: queryArg => ({ url: `/api/User/Preferences`, method: 'PUT', body: queryArg.jsonElement }),
        }),
        getApiUserInfo: build.query<GetApiUserInfoApiResponse, GetApiUserInfoApiArg>({
            query: () => ({ url: `/api/UserInfo` }),
        }),
        getApiUserInfoExtended: build.query<GetApiUserInfoExtendedApiResponse, GetApiUserInfoExtendedApiArg>({
            query: () => ({ url: `/api/UserInfo/Extended` }),
        }),
        syncDetails: build.query<SyncDetailsApiResponse, SyncDetailsApiArg>({
            query: () => ({ url: `/api/Service/SyncDetails` }),
        }),
        projectsInfo: build.query<ProjectsInfoApiResponse, ProjectsInfoApiArg>({
            query: () => ({ url: `/api/Service/ProjectsInfo` }),
        }),
        workerData: build.query<WorkerDataApiResponse, WorkerDataApiArg>({
            query: () => ({ url: `/api/DataStaging/WorkerData` }),
        }),
        postApiPublicHandleByActionLink: build.mutation<
            PostApiPublicHandleByActionLinkApiResponse,
            PostApiPublicHandleByActionLinkApiArg
        >({
            query: queryArg => ({ url: `/api/Public/Handle/${queryArg.actionLink}`, method: 'POST' }),
        }),
        getApiPublicRequestInfoByRequestId: build.query<
            GetApiPublicRequestInfoByRequestIdApiResponse,
            GetApiPublicRequestInfoByRequestIdApiArg
        >({
            query: queryArg => ({ url: `/api/Public/RequestInfo/${queryArg.requestId}` }),
        }),
        getVersion: build.query<GetVersionApiResponse, GetVersionApiArg>({
            query: () => ({ url: `/api/version` }),
        }),
        getCommandTemplatePermissions: build.query<
            GetCommandTemplatePermissionsApiResponse,
            GetCommandTemplatePermissionsApiArg
        >({
            query: queryArg => ({ url: `/api/Heappe/CommandTemplatePermissions/${queryArg.heappeIdentifier}` }),
        }),
        getCommandTemplates: build.query<GetCommandTemplatesApiResponse, GetCommandTemplatesApiArg>({
            query: queryArg => ({
                url: `/api/Heappe/CommandTemplate/${queryArg.projectShortName}/${queryArg.projectResourceName}`,
            }),
        }),
        activateCommandTemplate: build.mutation<ActivateCommandTemplateApiResponse, ActivateCommandTemplateApiArg>({
            query: queryArg => ({
                url: `/api/Heappe/CommandTemplate/Activate`,
                method: 'PUT',
                body: queryArg.commandTemplateActivateRequest,
            }),
        }),
        deactivateCommandTemplate: build.mutation<
            DeactivateCommandTemplateApiResponse,
            DeactivateCommandTemplateApiArg
        >({
            query: queryArg => ({
                url: `/api/Heappe/CommandTemplate/Deactivate`,
                method: 'PUT',
                body: queryArg.commandTemplateActivateRequest,
            }),
        }),
        syncCommandTemplate: build.mutation<SyncCommandTemplateApiResponse, SyncCommandTemplateApiArg>({
            query: queryArg => ({
                url: `/api/Heappe/CommandTemplate/Synchronization`,
                method: 'POST',
                body: queryArg.commandTemplateSyncRequest,
            }),
        }),
        getPartitionsEndpoint: build.query<GetPartitionsEndpointApiResponse, GetPartitionsEndpointApiArg>({
            query: queryArg => ({
                url: `/api/Heappe/Partitions/${queryArg.projectShortName}/${queryArg.resourceName}`,
            }),
        }),
        createTemplateEndpoint: build.mutation<CreateTemplateEndpointApiResponse, CreateTemplateEndpointApiArg>({
            query: queryArg => ({
                url: `/api/Heappe/CommandTemplates`,
                method: 'POST',
                body: queryArg.createTemplateRequest,
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as userOrg };
export type GetApiEnumsRequestStatesApiResponse = /** status 200 OK */ any;
export type GetApiEnumsRequestStatesApiArg = void;
export type GetApiEnumsRequestTypesApiResponse = /** status 200 OK */ any;
export type GetApiEnumsRequestTypesApiArg = void;
export type GetApiEnumsOperationModeResponsesApiResponse = /** status 200 OK */ any;
export type GetApiEnumsOperationModeResponsesApiArg = void;
export type GetApiHeappeListChangedFilesForJobByProjectShortNameAndResourceNameSubmittedJobInfoIdApiResponse =
    /** status 200 OK */ {
        [key: string]: DownloadedFileModel;
    };
export type GetApiHeappeListChangedFilesForJobByProjectShortNameAndResourceNameSubmittedJobInfoIdApiArg = {
    projectShortName: ProjectShortName;
    submittedJobInfoId: any;
    resourceName: string;
};
export type GetApiOtherCountryApiResponse = /** status 200 OK */ CountryModel[];
export type GetApiOtherCountryApiArg = {
    countryCode?: string;
};
export type GetApiOtherStatisticsApiResponse = /** status 200 OK */ StatisticsModel;
export type GetApiOtherStatisticsApiArg = {
    fromDate?: string;
    toDate?: string;
};
export type GetApiOtherCyclopsUsageByProjectShortNameAndResourceNameApiResponse = unknown;
export type GetApiOtherCyclopsUsageByProjectShortNameAndResourceNameApiArg = {
    fromDate?: string;
    toDate?: string;
    projectShortName: ProjectShortName;
    resourceName: string;
};
export type GetApiProjectByProjectShortNameUsersApiResponse = /** status 200 OK */ ProjectUserModel[];
export type GetApiProjectByProjectShortNameUsersApiArg = {
    projectShortName: ProjectShortName;
};
export type GetProjectApiResponse = /** status 200 OK */ ProjectModel[];
export type GetProjectApiArg = {
    projectShortName?: ProjectShortName;
};
export type PostApiProjectApiResponse = unknown;
export type PostApiProjectApiArg = {
    projectCreate: ProjectCreate;
};
export type PutApiProjectApiResponse = unknown;
export type PutApiProjectApiArg = {
    projectUpdate: ProjectUpdate;
};
export type PutApiProjectByProjectShortNameUserAndIdpUserIdAssignRoleIdApiResponse = unknown;
export type PutApiProjectByProjectShortNameUserAndIdpUserIdAssignRoleIdApiArg = {
    projectShortName: ProjectShortName;
    idpUserId: string;
    roleId: any;
};
export type DeleteApiProjectByProjectShortNameApiResponse = unknown;
export type DeleteApiProjectByProjectShortNameApiArg = {
    projectShortName: ProjectShortName;
};
export type PutApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiResponse = unknown;
export type PutApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiArg = {
    projectShortName: ProjectShortName;
    projectResourceName: string;
};
export type DeleteApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiResponse = unknown;
export type DeleteApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiArg = {
    projectShortName: ProjectShortName;
    projectResourceName: string;
};
export type PutApiProjectByProjectShortNameUserAndIdpUserIdApiResponse = unknown;
export type PutApiProjectByProjectShortNameUserAndIdpUserIdApiArg = {
    projectShortName: ProjectShortName;
    idpUserId: string;
};
export type DeleteApiProjectByProjectShortNameUserAndIdpUserIdApiResponse = unknown;
export type DeleteApiProjectByProjectShortNameUserAndIdpUserIdApiArg = {
    projectShortName: ProjectShortName;
    idpUserId: string;
};
export type PutApiProjectByProjectShortNameProjectTagAndProjectTagIdApiResponse = unknown;
export type PutApiProjectByProjectShortNameProjectTagAndProjectTagIdApiArg = {
    projectShortName: ProjectShortName;
    projectTagId: string;
};
export type DeleteApiProjectByProjectShortNameProjectTagAndProjectTagIdApiResponse = unknown;
export type DeleteApiProjectByProjectShortNameProjectTagAndProjectTagIdApiArg = {
    projectShortName: ProjectShortName;
    projectTagId: string;
};
export type TemplatesInfoApiResponse = /** status 200 OK */ TemplateInfoResponse[];
export type TemplatesInfoApiArg = {
    projectShortName: ProjectShortName;
    noCache?: boolean;
};
export type ExtendedProjectInfoApiResponse = /** status 200 OK */ ExtendedProjectModel[];
export type ExtendedProjectInfoApiArg = {
    projectShortName: ProjectShortName;
};
export type ValidRolesApiResponse = /** status 200 OK */ SystemRoleModel[];
export type ValidRolesApiArg = {
    projectShortName: ProjectShortName;
};
export type GetApiProjectResourceAssignmentApiResponse = /** status 200 OK */ ProjectResourceAssignmentModel[];
export type GetApiProjectResourceAssignmentApiArg = {
    projectResourceId?: string;
};
export type PostApiProjectResourceAssignmentApiResponse = unknown;
export type PostApiProjectResourceAssignmentApiArg = {
    projectResourceAssignmentCreate: ProjectResourceAssignmentCreate;
};
export type PutApiProjectResourceAssignmentApiResponse = unknown;
export type PutApiProjectResourceAssignmentApiArg = {
    projectResourceAssignmentUpdate: ProjectResourceAssignmentUpdate;
};
export type GetProjectResourceAssignmentApiResponse = /** status 200 OK */ ProjectResourceAssignmentModel;
export type GetProjectResourceAssignmentApiArg = {
    id: string;
};
export type DeleteApiProjectResourceAssignmentByIdApiResponse = unknown;
export type DeleteApiProjectResourceAssignmentByIdApiArg = {
    id: string;
};
export type GetApiProjectResourceApiResponse = /** status 200 OK */ ProjectResourceModel[];
export type GetApiProjectResourceApiArg = {
    projectShortName?: ProjectShortName;
    locationTypeId?: any;
    startDate?: string;
    endDate?: string;
};
export type PostApiProjectResourceApiResponse = unknown;
export type PostApiProjectResourceApiArg = {
    projectResourceCreate: ProjectResourceCreate;
};
export type PutApiProjectResourceApiResponse = unknown;
export type PutApiProjectResourceApiArg = {
    projectResourceUpdate: ProjectResourceUpdate;
};
export type GetProjectResourceApiResponse = /** status 200 OK */ ProjectResourceModel;
export type GetProjectResourceApiArg = {
    id: string;
};
export type DeleteApiProjectResourceByIdApiResponse = unknown;
export type DeleteApiProjectResourceByIdApiArg = {
    id: string;
};
export type GetApiProjectTagApiResponse = /** status 200 OK */ ProjectTagModel[];
export type GetApiProjectTagApiArg = {
    tagName?: string;
};
export type PostApiProjectTagApiResponse = unknown;
export type PostApiProjectTagApiArg = {
    projectTagCreate: ProjectTagCreate;
};
export type PutApiProjectTagApiResponse = unknown;
export type PutApiProjectTagApiArg = {
    projectTagUpdate: ProjectTagUpdate;
};
export type GetProjectTagApiResponse = /** status 200 OK */ ProjectTagModel;
export type GetProjectTagApiArg = {
    id: string;
};
export type DeleteApiProjectTagByIdApiResponse = unknown;
export type DeleteApiProjectTagByIdApiArg = {
    id: string;
};
export type GetApiRequestsApiResponse = /** status 200 OK */ RequestModel[] | /** status 204 No Content */ Blob;
export type GetApiRequestsApiArg = {
    state?: ERequestState;
    type?: ERequestType;
    projectShortName?: ProjectShortName;
};
export type PostApiRequestsApiResponse = unknown;
export type PostApiRequestsApiArg = {
    requestCreate: RequestCreate;
};
export type GetApiRequestsSentRequestsApiResponse =
    /** status 200 OK */
    RequestModel[] | /** status 204 No Content */ Blob;
export type GetApiRequestsSentRequestsApiArg = {
    state?: ERequestState;
    type?: ERequestType;
    projectShortName?: ProjectShortName;
};
export type PutApiRequestsByRequestIdAcceptApiResponse = unknown;
export type PutApiRequestsByRequestIdAcceptApiArg = {
    requestId: string;
};
export type PutApiRequestsByRequestIdRejectApiResponse = unknown;
export type PutApiRequestsByRequestIdRejectApiArg = {
    requestId: string;
    reason?: string;
};
export type GetApiUserPreferencesApiResponse = /** status 200 OK */ string;
export type GetApiUserPreferencesApiArg = void;
export type PutApiUserPreferencesApiResponse = /** status 200 OK */ string;
export type PutApiUserPreferencesApiArg = {
    jsonElement: JsonElement;
};
export type GetApiUserInfoApiResponse = /** status 200 OK */ UserInfoModel;
export type GetApiUserInfoApiArg = void;
export type GetApiUserInfoExtendedApiResponse = /** status 200 OK */ UserInfoExtendedModel;
export type GetApiUserInfoExtendedApiArg = void;
export type SyncDetailsApiResponse = /** status 200 OK */ UserInfoExtendedModel[];
export type SyncDetailsApiArg = void;
export type ProjectsInfoApiResponse = /** status 200 OK */ ProjectInfoModel[];
export type ProjectsInfoApiArg = void;
export type WorkerDataApiResponse = /** status 200 OK */ DataStagingDataModel;
export type WorkerDataApiArg = void;
export type PostApiPublicHandleByActionLinkApiResponse = unknown;
export type PostApiPublicHandleByActionLinkApiArg = {
    actionLink: string;
};
export type GetApiPublicRequestInfoByRequestIdApiResponse = /** status 200 OK */ PublicRequestModel;
export type GetApiPublicRequestInfoByRequestIdApiArg = {
    requestId: string;
};
export type GetVersionApiResponse = /** status 200 OK */ string;
export type GetVersionApiArg = void;
export type GetCommandTemplatePermissionsApiResponse = /** status 200 OK */ UserCommandTemplatePermissionModel;
export type GetCommandTemplatePermissionsApiArg = {
    heappeIdentifier: string;
};
export type GetCommandTemplatesApiResponse = /** status 200 OK */ CommandTemplateResponse[];
export type GetCommandTemplatesApiArg = {
    projectShortName: string;
    projectResourceName: string;
};
export type ActivateCommandTemplateApiResponse = unknown;
export type ActivateCommandTemplateApiArg = {
    commandTemplateActivateRequest: CommandTemplateActivateRequest;
};
export type DeactivateCommandTemplateApiResponse = unknown;
export type DeactivateCommandTemplateApiArg = {
    commandTemplateActivateRequest: CommandTemplateActivateRequest;
};
export type SyncCommandTemplateApiResponse = /** status 200 OK */ CommandTemplateSyncResult;
export type SyncCommandTemplateApiArg = {
    commandTemplateSyncRequest: CommandTemplateSyncRequest;
};
export type GetPartitionsEndpointApiResponse = /** status 200 OK */ LocationPartitionResponse[];
export type GetPartitionsEndpointApiArg = {
    projectShortName: string;
    resourceName: string;
};
export type CreateTemplateEndpointApiResponse = unknown;
export type CreateTemplateEndpointApiArg = {
    createTemplateRequest: CreateTemplateRequest;
};
export type DownloadedFileModel = {
    FileName: any;
    TextContent: any;
};
export type ProjectShortName = any;
export type CountryModel = {
    Code?: any;
    Name?: any;
};
export type WeeklyDataModel = {
    From: string;
    To: string;
    ProjectsCreated: any;
    UsersCreated: any;
    ResourcesCreated: any;
};
export type StatisticsModel = {
    NumberOfProjects: any;
    NumberOfUsers: any;
    NumberOfResources: any;
    WeeklyData: WeeklyDataModel[];
};
export type ProjectUserModel = {
    IdpUserId: string;
    Email: string;
    RoleName: string;
};
export type ProjectId = any;
export type EOperationModeResponse = 'Unspecified' | 'ReadOnly' | 'Editable';
export type ProjectModel = {
    Id?: null | ProjectId;
    Name?: any;
    ShortName?: any;
    Description?: any;
    ContactEmail?: any;
    StartDate?: any;
    EndDate?: any;
    DomainId?: any;
    OperationMode?: EOperationModeResponse;
    AssignedProjectResourceIds?: string[];
    AssignedTags?: string[];
};
export type ProjectCreate = {
    Name?: any;
    ShortName?: any;
    Description?: any;
    ContactEmail?: any;
    StartDate?: string;
    EndDate?: string;
    DomainId?: any;
};
export type ProjectUpdate = {
    Name?: any;
    ShortName?: ProjectShortName;
    Description?: any;
    ContactEmail?: any;
    StartDate?: string;
    EndDate?: string;
    DomainId?: any;
};
export type TemplateParameterModel = {
    Identifier?: any;
    Description?: any;
};
export type CommandTemplate = {
    Id: any;
    Name: string;
    IsGeneric: boolean;
    Parameters: TemplateParameterModel[];
};
export type NodeAllocation = {
    LexisResourceName: string;
    CommandTemplates: CommandTemplate[];
};
export type NodeInfo = {
    NodeId: any;
    NodeType: string;
    NumberOfNodes: any;
    ClusterPerNode: any;
    MaxWallTime: any;
    FileTransferMethodId: any;
    Allocations: NodeAllocation[];
};
export type TemplateInfoResponse = {
    IsAvailable: boolean;
    ClusterName: string;
    LocationId: string;
    ClusterId: any;
    Nodes: NodeInfo[];
};
export type KeyValuePairOfstringAndstring = {
    Key: any;
    Value: any;
};
export type ProjectResourceAssignmentExtendedModel = {
    ProjectResourceName?: any;
    LocationName?: any;
    AllocationAmount?: any;
    AllocationUnitTypeName?: any;
    AggregationName?: any;
    Specifications?: KeyValuePairOfstringAndstring[];
    LocationTypeId?: any;
};
export type ExtendedProjectModel = {
    Name?: any;
    ShortName?: any;
    Description?: any;
    ContactEmail?: any;
    StartDate?: any;
    EndDate?: any;
    DomainId?: any;
    AssignedProjectResources?: ProjectResourceAssignmentExtendedModel[];
    AssignedTags?: string[];
};
export type SystemRoleModel = {
    Name: string;
    Id: any;
    Description: any;
    SystemPermissions: string[];
};
export type ProjectResourceAssignmentModel = {
    Id?: any;
    ProjectResourceId?: any;
    LocationId?: any;
    LocationTypeId?: any;
    IsLocationShared?: boolean;
    LocationName: string;
    AllocationAmount?: any;
    AllocationUnitTypeId?: any;
    AggregationName?: any;
    OperationMode?: EOperationModeResponse;
    Specifications?: KeyValuePairOfstringAndstring[];
};
export type ProjectResourceAssignmentCreate = {
    ProjectResourceId?: any;
    LocationId?: any;
    AllocationAmount?: any;
    AllocationUnitTypeId?: any;
    AggregationName?: any;
    Specifications?: KeyValuePairOfstringAndstring[];
};
export type ProjectResourceAssignmentUpdate = {
    Id?: any;
    AllocationAmount?: any;
    AllocationUnitTypeId?: any;
    AggregationName?: any;
    Specifications?: KeyValuePairOfstringAndstring[];
    Description?: any;
};
export type ProjectResourceModel = {
    Id?: any;
    Name?: any;
    Description?: any;
    PrimaryInvestigatorEmail?: any;
    StartDate?: any;
    EndDate?: any;
    OperationMode?: EOperationModeResponse;
    Assignments?: ProjectResourceAssignmentModel[];
};
export type ProjectResourceCreate = {
    Name?: any;
    Description?: any;
    PrimaryInvestigatorEmail?: any;
    StartDate?: any;
    EndDate?: any;
};
export type ProjectResourceUpdate = {
    Id?: any;
    Name?: any;
    Description?: any;
    PrimaryInvestigatorEmail?: any;
    StartDate?: any;
    EndDate?: any;
};
export type ProjectTagModel = {
    Id?: any;
    Name?: any;
    Description?: any;
};
export type ProjectTagCreate = {
    Name?: any;
    Description?: any;
};
export type ProjectTagUpdate = {
    Id?: any;
    Name?: any;
    Description?: any;
};
export type RequestModel = {
    RequestId?: any;
    IdpUserId?: any;
    UserName?: any;
    Email?: any;
    ProjectShortName?: null | ProjectShortName;
    State?: any;
    Type?: any;
    LastModification?: string;
};
export type ERequestState = 'Pending' | 'PendingForPIAccept' | 'PendingForHPCProject' | 'Accepted' | 'Rejected';
export type ERequestType = 'Unknown' | 'SelfOnboarding' | 'ProjectResourceAssignment' | 'HEAppECreation';
export type RequestCreate = {
    ProjectShortName: ProjectShortName;
    RequestType: ERequestType;
    ProjectResourceName: any;
    ProviderId: any;
    ContactEmail: any;
};
export type JsonElement = any;
export type UserSystemRoleModel = {
    IdpUserId: string;
    UserEmail: string;
    RoleName: string;
    ProjectShortName: ProjectShortName;
    SystemPermissionTypes: string[];
};
export type UserInfoModel = {
    Id?: string;
    KeycloakSid?: any;
    Name?: any;
    UserName?: any;
    Email?: any;
    SystemRoles?: UserSystemRoleModel[];
};
export type LocationDetailModel = {
    Name: string;
    Descritpion: string;
    Endpoint: string;
    IsPrivate: boolean;
    Type: string;
    AllocationUnitCount: any;
    AllocationUnitType: string;
    Values: KeyValuePairOfstringAndstring[];
};
export type ProjectResourceDetailModel = {
    Name: string;
    Description: string;
    StartDate: any;
    EndDate: any;
    Locations: LocationDetailModel[];
};
export type UserSystemRoleExtendedModel = {
    ProjectShortName: ProjectShortName;
    UserEmail: string;
    RoleName: string;
    ProjectResources: ProjectResourceDetailModel[];
    SystemPermissionTypes: string[];
};
export type UserInfoExtendedModel = {
    Id?: string;
    KeycloakSid?: any;
    Name?: any;
    UserName?: any;
    Email?: any;
    SystemRoles?: UserSystemRoleExtendedModel[];
};
export type AssociatedProjectModel = {
    Id: string;
    ProjectName: string;
    ShortName: string;
    CollectorName: string;
    StartDate: any;
    EndDate: any;
};
export type ProjectResourceAssignmentServiceModel = {
    LocationName?: any;
    LocationDescription?: any;
    ResourceType?: any;
    AllocationAmount?: any;
    AllocationUnitTypeName?: any;
    AggregationName?: any;
    Specifications?: KeyValuePairOfstringAndstring[];
};
export type ProjectResourceServiceModel = {
    Id?: any;
    Name?: any;
    Description?: any;
    StartDate?: any;
    EndDate?: any;
    AssociatedProjects?: AssociatedProjectModel[];
    Assignments?: ProjectResourceAssignmentServiceModel[];
};
export type ProjectInfoModel = {
    ProviderId?: any;
    ProviderName?: any;
    ProviderDescription?: any;
    Resources?: ProjectResourceServiceModel[];
};
export type DataStagingPart = {
    Name: string;
    JsonData: string;
};
export type DataStagingDataModel = {
    Name: string;
    PublicData: DataStagingPart;
    PrivateData: DataStagingPart;
};
export type PublicRequestModel = {
    RequestId?: any;
    RequestorUserName?: any;
    RequestorEmail?: any;
    ProjectShortName?: ProjectShortName;
    ProjectResourceName?: any;
    ProviderName?: any;
    RequestState?: any;
    ValidTo?: string;
    RequestType?: any;
    AcceptActionLink?: any;
    RejectActionLink?: any;
};
export type CommandTemplateModel = {
    Name: string;
    Enabled: boolean;
};
export type PermissionModel = {
    QueueName: string;
    ProjectResource: string;
    ClusterName: string;
    ProjectShortName: string;
    CommandTemplates: CommandTemplateModel[];
};
export type UserCommandTemplatePermissionModel = {
    HeappeIdentifikator: string;
    Permissions: PermissionModel[];
};
export type ECommandTemplateTypeResponse = 'Unknown' | 'SystemDefined' | 'UserDefined';
export type ECommandTemplateStateResponse = string;
export type CommandTemplateResponse = {
    Id: string;
    Name: string;
    Type: ECommandTemplateTypeResponse;
    State: ECommandTemplateStateResponse;
    Frozen?: boolean;
};
export type CommandTemplateActivateRequest = {
    Id: string;
    ProjectShortName?: string;
    ResourceName?: string;
};
export type ErrorSeverity = 'Error' | 'Warning' | 'Info';
export type Error = {
    Severity: ErrorSeverity;
    Code: string;
    Description: string;
};
export type LocationSyncResultEntry = {
    LocationName: string;
    AggregationName: any;
    HeappeInstanceUri: string;
    IsSuccess: boolean;
    Errors: Error[];
};
export type CommandTemplateSyncResult = {
    Locations: LocationSyncResultEntry[];
    AllSucceeded?: boolean;
    AnySucceeded?: boolean;
};
export type CommandTemplateSyncRequest = {
    ProjectShortName?: string;
    ResourceName?: string;
};
export type LocationPartitionResponse = {
    PartitionName: string;
    AggregationName: string;
    LocationName: string;
    ProviderName: string;
};
export type ProjectResourceTarget = {
    ProjectShortName: string;
    ResourceName: string;
};
export type CreateCommandTemplateParameterDto = {
    Name: string;
    Description: string;
};
export type CreateTemplateRequest = {
    ProjectIdentifier: ProjectResourceTarget;
    PartitionName: string;
    LocationName: string;
    AggregationName: any;
    Name: string;
    Description: any;
    PreparationScriptPath: any;
    ExecutionScriptPath: any;
    CommandTemplateParameters: CreateCommandTemplateParameterDto[];
};
export const {
    useGetApiEnumsRequestStatesQuery,
    useGetApiEnumsRequestTypesQuery,
    useGetApiEnumsOperationModeResponsesQuery,
    useGetApiHeappeListChangedFilesForJobByProjectShortNameAndResourceNameSubmittedJobInfoIdQuery,
    useGetApiOtherCountryQuery,
    useGetApiOtherStatisticsQuery,
    useGetApiOtherCyclopsUsageByProjectShortNameAndResourceNameQuery,
    useGetApiProjectByProjectShortNameUsersQuery,
    useGetProjectQuery,
    usePostApiProjectMutation,
    usePutApiProjectMutation,
    usePutApiProjectByProjectShortNameUserAndIdpUserIdAssignRoleIdMutation,
    useDeleteApiProjectByProjectShortNameMutation,
    usePutApiProjectByProjectShortNameProjectResourceAndProjectResourceNameMutation,
    useDeleteApiProjectByProjectShortNameProjectResourceAndProjectResourceNameMutation,
    usePutApiProjectByProjectShortNameUserAndIdpUserIdMutation,
    useDeleteApiProjectByProjectShortNameUserAndIdpUserIdMutation,
    usePutApiProjectByProjectShortNameProjectTagAndProjectTagIdMutation,
    useDeleteApiProjectByProjectShortNameProjectTagAndProjectTagIdMutation,
    useTemplatesInfoQuery,
    useExtendedProjectInfoQuery,
    useValidRolesQuery,
    useGetApiProjectResourceAssignmentQuery,
    usePostApiProjectResourceAssignmentMutation,
    usePutApiProjectResourceAssignmentMutation,
    useGetProjectResourceAssignmentQuery,
    useDeleteApiProjectResourceAssignmentByIdMutation,
    useGetApiProjectResourceQuery,
    usePostApiProjectResourceMutation,
    usePutApiProjectResourceMutation,
    useGetProjectResourceQuery,
    useDeleteApiProjectResourceByIdMutation,
    useGetApiProjectTagQuery,
    usePostApiProjectTagMutation,
    usePutApiProjectTagMutation,
    useGetProjectTagQuery,
    useDeleteApiProjectTagByIdMutation,
    useGetApiRequestsQuery,
    usePostApiRequestsMutation,
    useGetApiRequestsSentRequestsQuery,
    usePutApiRequestsByRequestIdAcceptMutation,
    usePutApiRequestsByRequestIdRejectMutation,
    useGetApiUserPreferencesQuery,
    usePutApiUserPreferencesMutation,
    useGetApiUserInfoQuery,
    useGetApiUserInfoExtendedQuery,
    useSyncDetailsQuery,
    useProjectsInfoQuery,
    useWorkerDataQuery,
    usePostApiPublicHandleByActionLinkMutation,
    useGetApiPublicRequestInfoByRequestIdQuery,
    useGetVersionQuery,
    useGetCommandTemplatePermissionsQuery,
    useGetCommandTemplatesQuery,
    useActivateCommandTemplateMutation,
    useDeactivateCommandTemplateMutation,
    useSyncCommandTemplateMutation,
    useGetPartitionsEndpointQuery,
    useCreateTemplateEndpointMutation,
} = injectedRtkApi;
